import type {
  ProactiveProposalStatus,
  VendorChangeRequestStatus,
  VendorChangeRequestType,
} from './types';

export const VENDOR_PLATFORM_NAME = '惠生合作供應商平台';

export const VENDOR_PROPOSAL_DELETABLE_STATUSES: readonly string[] = [
  'DRAFT',
  'VENDOR_REVISING',
  'REVISION_REQUIRED',
];

export const VENDOR_CHANGE_REQUEST_STATUS_LABELS: Record<VendorChangeRequestStatus, string> = {
  DRAFT: '草稿',
  SUBMITTED: '已送出',
  PENDING: '待處理',
  NEEDS_INFO: '要求補充',
  RETURNED: '退回修改',
  APPROVED: '已核准',
  REJECTED: '不同意',
  APPLIED: '已套用',
};

export const VENDOR_CHANGE_REQUEST_TYPE_LABELS: Record<VendorChangeRequestType, string> = {
  VENDOR_PROFILE: '廠商資料變更',
  PROPOSAL: '新品資料／報價變更',
};

export const VENDOR_PROPOSAL_LOCKED_STATUSES: readonly ProactiveProposalStatus[] = [
  'SUBMITTED',
  'WAITING_INITIAL_SCREEN',
  'BUYER_REVIEW',
  'PASSED_INITIAL_SCREEN',
  'WAITING_MEETING',
  'APPROVED',
  'PAUSED',
  'NOT_ADOPTED',
  'CONVERTED_TO_FORMAL_CASE',
  'MASTER_CREATED',
];

export function vendorChangeRequestStatusLabel(status: string): string {
  return VENDOR_CHANGE_REQUEST_STATUS_LABELS[status as VendorChangeRequestStatus] ?? status;
}

export function vendorChangeRequestTypeLabel(type: string): string {
  return VENDOR_CHANGE_REQUEST_TYPE_LABELS[type as VendorChangeRequestType] ?? type;
}

export function canVendorEditProposal(status: string): boolean {
  return status === 'DRAFT' || status === 'VENDOR_REVISING' || status === 'REVISION_REQUIRED';
}

export function canVendorRequestProposalChange(status: string): boolean {
  return VENDOR_PROPOSAL_LOCKED_STATUSES.includes(status as ProactiveProposalStatus);
}

export function canVendorDeleteProposal(status: string): boolean {
  return VENDOR_PROPOSAL_DELETABLE_STATUSES.includes(status);
}
